import { RangeInterval } from '@/components/line-chart/types';

export async function fetchStockByInterval(
  idOfProduct: string,
  interval: RangeInterval,
) {
  const response = await fetch(
    `/backend/MarketData/history/${idOfProduct}/${interval}/`,
  );
  if (!response.ok) {
    console.error(`Failed to fetch stocks`);
    return null;
  }

  const data = await response.json();
  return data;
}

export async function getSearchResult(query: string) {
  const response = await fetch(`/backend/MarketData/search/?Query=${query}`);
  if (!response.ok) {
    console.error(`Failed to fetch stocks`);
    return null;
  }

  const data = await response.json();
  return data;
}
